/**
 * Represents different types of rounding strategies.
 */
export enum RoundingModel {
	/**
	 * Round up to the nearest value.
	 */
	Up = 1,
	/**
	 * Round to the nearest package size.
	 */
	Package = 2,
	/**
	 * Round to the nearest integer value.
	 */
	Integer = 3
}
